import React, { forwardRef } from 'react';
import Link from 'next/link';
import Router from 'next/router';
import { connect } from 'react-redux';
import actions from '../../reduxStore/action';

const connectAndForwardRef = (mapStateToProps = null, mapDispatchToProps = null, mergeProps = null, options = {}) => (
  component,
) => connect(mapStateToProps, mapDispatchToProps, mergeProps, {
  ...options,
  forwardRef: true,
})(component);

const Logout = forwardRef(({
  className, children, logout,
}, ref) => (
  <a
    ref={ref}
    className={className}
    onClick={() => {
      Router.push('/login');

      logout();
    }}
  >
    {children}
  </a>
));

const LogoutComponent = connectAndForwardRef(null, actions)(Logout);

const LinkComponent = forwardRef(({
  className, href, hrefAs, children,
}, ref) => (
  <Link href={href} as={hrefAs} ref={ref}>
    <a className={className}>{children}</a>
  </Link>
));

export { LinkComponent, LogoutComponent };
